module.exports = __webpack_public_path__ + "img/telegram-share.9d234c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/telegram-share.png
// module id = T5RI
// module chunks = 13